if (!customElements.get('op-rich-product-description')) {
    class OpRichProductDescription extends HTMLElement {
        connectedCallback() {
            this.description = this.querySelector('.js-description');
            this.details = this.querySelector('.js-details');
            this.summary = this.querySelector('.js-summary');
            this.animationContainer = this.querySelector('.js-animation-container');
            
            if (!this.description || !this.details || !this.summary || !this.animationContainer) {
                console.error('Required elements not found in op-rich-product-description', this);
                return;
            }

            const isShortDescription = this.description.scrollHeight < 84
            this.details.open = isShortDescription;
            this.summary.classList.toggle('tw-hidden', isShortDescription);
            this.summary.classList.toggle('tw-flex', !isShortDescription);

            if (!isShortDescription) this.animationContainer.classList.add('tw-transition-all', 'tw-duration-500');

            this.pSubtitle = this.querySelector("#product-subtitle");
            this.pTitle = document.querySelector("#product-title");
            this.pDescription = this.querySelector("#product-description");
            this.currentSize = this.querySelector("#current-size");
            this.templeLength = this.querySelector("#temple-length");

            this.changeText("default");

            subscribe(PUB_SUB_EVENTS.faceSizeSelection, (e) => {
                console.log(e.data);
                this.changeText(e.data.range.key);
                this.changeDimensions(e.data.variant);
            })
        }

        changeDimensions(variant) {
            this.templeLength.innerHTML = `${variant.temple_length}mm`;
            this.currentSize.innerHTML = `${variant.model_size}-${variant.seg_height}`;
        }

        changeText(range) {
            this.pTitle.innerHTML = this.getValue(range, this.pTitle);
            this.pSubtitle.innerHTML = this.getValue(range, this.pSubtitle);
            this.pDescription.innerHTML = this.getValue(range, this.pDescription);
        }

        getValue(range, elem) {
            switch (range) {
                case FACE_SIZE_RANGE.narrow.key:
                    return elem.dataset.petite;
                case FACE_SIZE_RANGE.average.key: 
                    return elem.dataset.standard;
                case FACE_SIZE_RANGE.wide.key:
                    return elem.dataset.generous;
                default:
                    return elem.dataset.standard;
            }
        }
    }
    customElements.define('op-rich-product-description', OpRichProductDescription);
}